module.exports = __webpack_public_path__ + "static/gallery_peak_2-2a4cea69b88036cb5cf19705c242a4c5.jpg";